import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	width: 100%;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px 0;
	width: 1135px;
`;

export const ActionsWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const Title = styled.div`
	font-size: 13px;
	line-height: 13px;
	color: ${colors.grey5};
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 1135px;
`;
